import { Button } from '@/components';
import Table from '@/components/common/table/Table';
import { usePaymentReminder } from '@/context/paymentReminderContext/PaymentReminderContextProvider';
import React, { useEffect, useState } from 'react';

const AbortMailList = ({ closeModal }) => {
  const {
    getPendingMailRecordsAPI,
    pendingMailRec,
    abortMailList,
    setAbortMailList,
    abortMailApi,
  } = usePaymentReminder();

  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    getPendingMailRecordsAPI();
    setAbortMailList(null); // set to null on first render
  }, []);

  const handleClose = () => {
    closeModal();
  };

  useEffect(() => {
    if (selectedIds.length === 0) {
      setAbortMailList(null);
    } else {
      const selectedObjects =
        pendingMailRec?.filter((row) => selectedIds.includes(row.id)) || [];
      setAbortMailList(selectedObjects);
    }
  }, [selectedIds, pendingMailRec, setAbortMailList]);

  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = pendingMailRec?.map((row) => row.id) || [];
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };

  const isAllSelected =
    pendingMailRec?.length > 0 && selectedIds.length === pendingMailRec.length;

  const columns = [
    { header: 'Customer Code', field: 'customer.customerCode' },
    { header: 'Customer Name', field: 'customer.customerName' },
    { header: 'Email', field: 'email1' },
    { header: 'Email 1', field: 'email2' },
    {
      header: 'Actions',
      render: (row) => (
        <div>
          <input
            type="checkbox"
            checked={selectedIds.includes(row.id)}
            onChange={() => handleCheckboxChange(row.id)}
            data-testid={`row-checkbox-${row.id}`}
          />
        </div>
      ),
    },
  ];

  // Add this check before rendering anything
  if (
    (Array.isArray(pendingMailRec) && pendingMailRec[0] === 'No Data Found') ||
    (Array.isArray(pendingMailRec) && pendingMailRec[0] === 'No data found')
  ) {
    return (
      <div className="text-center text-gray-500 py-8">
        No pending mail records found.
      </div>
    );
  }

  return (
    <div>
      <div
        style={{ marginBottom: 12 }}
        className="flex justify-end items-center gap-4"
      >
        <input
          type="checkbox"
          checked={isAllSelected}
          onChange={handleSelectAll}
          data-testid="select-all-checkbox"
        />
        <span style={{ marginLeft: 8, fontSize: 14 }}>Select All</span>
      </div>
      {Array.isArray(pendingMailRec) &&
      pendingMailRec[0] === 'No Data Found' ? null : (
        <Table data={pendingMailRec} columns={columns} isForSorting={false} />
      )}
      <div className="flex justify-end">
        <Button
          className="btn btn-danger"
          disabled={!abortMailList || abortMailList.length === 0}
          onClick={() => abortMailApi(abortMailList, handleClose)}
        >
          Abort
        </Button>
      </div>
    </div>
  );
};

export default AbortMailList;
